import { END_POINTS, REQUEST_TYPE } from "../lib/variables";
import Api from "./index";

const getCustomPackages = () => {
  return Api(END_POINTS.packages, null, REQUEST_TYPE.GET);
};

const createUserPackage = (payload) => {
  return Api(END_POINTS.userPackageCreate, payload, REQUEST_TYPE.POST);
};

const getAllUserPackage = (id) => {
  return Api(`${END_POINTS.getAllUserPackage}/${id}`, null, REQUEST_TYPE.GET);
};

const userPackageDetail = (id) => {
  return Api(`${END_POINTS.userPackageDetail}/${id}`, null, REQUEST_TYPE.GET);
};

const userPackageDetailByUrl = (url) => {
  return Api(
    `${END_POINTS.userPackageDetailByUrl}/${url}`,
    null,
    REQUEST_TYPE.GET
  );
};

export {
  createUserPackage,
  getAllUserPackage,
  userPackageDetail,
  userPackageDetailByUrl,
  getCustomPackages,
};
